module.exports = __webpack_public_path__ + "img/theme-edu_logo-grey.000f80de.png";